'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { SECTION_HEADER_MAX_W } from '@/app/(allowed)/search/constants';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useSearchHistoryStore } from './_store/searchHistoryStore';
import { useSearchOverlayStore } from './_store/searchOverlayStore';
import { DEFAULT_SEARCH_CATEGORY, isSearchCategory, SEARCH_CATEGORY_QUERY_KEY } from './constants';
import { HeaderSearchOverlay } from './HeaderSearchOverlay';
export function HeaderSearchContainer() {
  const $ = _c(22);
  const {
    replace,
    push
  } = useCustomRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isOpen = useSearchOverlayStore(_temp);
  const closeOverlay = useSearchOverlayStore(_temp2);
  const data = useSearchHistoryStore(_temp3);
  const add = useSearchHistoryStore(_temp4);
  const remove = useSearchHistoryStore(_temp5);
  const clear = useSearchHistoryStore(_temp6);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("q") ?? "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentKeyword = t0;
  let t1;
  if ($[2] !== searchParams) {
    const categoryParam = searchParams.get(SEARCH_CATEGORY_QUERY_KEY);
    t1 = isSearchCategory(categoryParam) ? categoryParam : DEFAULT_SEARCH_CATEGORY;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentCategory = t1;
  let t2;
  if ($[4] !== add || $[5] !== closeOverlay || $[6] !== currentCategory || $[7] !== pathname || $[8] !== push || $[9] !== replace) {
    t2 = keyword => {
      const trimmed = keyword.trim();
      add(trimmed);
      closeOverlay();
      const nextParams = new URLSearchParams();
      nextParams.set("q", trimmed);
      if (currentCategory !== DEFAULT_SEARCH_CATEGORY) {
        nextParams.set(SEARCH_CATEGORY_QUERY_KEY, currentCategory);
      }
      const url = `${ROUTES.SEARCH.pathname}?${nextParams.toString()}`;
      if (pathname === ROUTES.SEARCH.pathname) {
        replace(url, {
          scroll: false
        });
        window.scrollTo(0, 0);
      } else {
        push(url);
      }
    };
    $[4] = add;
    $[5] = closeOverlay;
    $[6] = currentCategory;
    $[7] = pathname;
    $[8] = push;
    $[9] = replace;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const submit = t2;
  let t3;
  if ($[11] !== data) {
    t3 = data ?? [];
    $[11] = data;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const t4 = SECTION_HEADER_MAX_W[currentCategory];
  let t5;
  if ($[13] !== clear || $[14] !== closeOverlay || $[15] !== currentKeyword || $[16] !== isOpen || $[17] !== remove || $[18] !== submit || $[19] !== t3 || $[20] !== t4) {
    t5 = <HeaderSearchOverlay isOpen={isOpen} keyword={currentKeyword} onClose={closeOverlay} onSearch={submit} recentKeywords={t3} onSelectRecent={submit} onRemoveRecent={remove} onClearRecent={clear} searchBarMaxWClass={t4} />;
    $[13] = clear;
    $[14] = closeOverlay;
    $[15] = currentKeyword;
    $[16] = isOpen;
    $[17] = remove;
    $[18] = submit;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}
function _temp6(state_4) {
  return state_4.clear;
}
function _temp5(state_3) {
  return state_3.remove;
}
function _temp4(state_2) {
  return state_2.add;
}
function _temp3(state_1) {
  return state_1.data;
}
function _temp2(state_0) {
  return state_0.closeOverlay;
}
function _temp(state) {
  return state.isOverlayOpen;
}